import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '@/utils/validators';
import Overlay from '@/forms/_common/Overlay';
import FormErrors from '@/forms/_common/FormErrors';
import RequestError from '@/forms/_common/RequestError';
import ErrorMessage from '@/forms/_common/ErrorMessage';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import Form from './Form';
import FindOrCreateOrganization from './FindOrCreateOrganization';
import { useQueryMutation } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import { useQueryClient } from '@tanstack/react-query';
import storage, { SCHOOL_DRAFT_KEY } from '@/utils/storage';

export default function CreateOrganizationDialog(props) {
  const { onCancel } = props;

  const currentUser = useUser();
  const queryClient = useQueryClient();


  const [data, setData] = useState({
    siteId: '',
    name: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    state: '',
    zipCode: '',
    title: '',
    type: 'Custom'
  });
  const [showErrors, setShowErrors] = useState(false);
  const [finished, setFinished] = useState(false);

  const mutation = useQueryMutation('role.create');
  const { saving, success, error, request } = mutation;

  const [siteId] = useState(null);

  const [organizationRequest, setOrganizationRequest] = useState({
    request: undefined,
    saving: false,
    success: false,
    error: false
  });

  useEffect(() => {
    // if (organizationRequest && organizationRequest.success && !organizationFinished) {
    //   setOrganizationFinished(true);
    //   mutation.mutate({
    //     userId: user.id,
    //     siteId: data.siteId,
    //     title: data.title
    //   });
    // }

    if (success && !finished) {
      setFinished(true);
      props.onCancel();
      props.onSubmit && props.onSubmit(request);
    }
  });

  async function onSubmit() {
    // mutation.reset();
    // setOrganizationFinished(false);
    // setOrganizationRequest({
    //   request: undefined,
    //   saving: false,
    //   success: false,
    //   error: false
    // });
    // setSiteId(data.siteId || data.name);
    await mutation.mutateAsync({
      userId: currentUser.id,
      siteId: data.siteId,
      title: data.title
    });
    storage.delete(SCHOOL_DRAFT_KEY);
    // some roles are included in the user record so clear it
    await queryClient.invalidateQueries(['currentUser'])
  }

  return (
    <DialogTemplate className="w-screen max-w-md">
      {siteId && !organizationRequest.request && (
        <FindOrCreateOrganization
          key={siteId}
          siteId={siteId}
          data={data}
          user={currentUser}
          onSubmit={(result) => setOrganizationRequest(result)}
        />
      )}
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          name: [validators.isRequired],
          title: [validators.isRequired],
          // type: [validators.isRequired]
        }}>
          {({ errors, hasError }) => (
            <Form
              user={currentUser}
              data={data}
              errors={errors}
              showErrors={showErrors}
              onChange={(name, value) => {
                setData(_.merge({}, data, {
                  [name]: value
                }));
              }}
              onChangeMultiple={(values) => {
                setData(_.merge({}, data, values));
              }}
              onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
              onCancel={onCancel}
              alert={error ? (
                <RequestError request={request} />
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : null}
            />
          )}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};

CreateOrganizationDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};
